export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  readTime: string;
  viewCount: number;
  likeCount: number;
  commentCount: number;
  tags: string[];
  imageUrl: string;
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: '1',
    slug: 'sakura-dream-illustration-tutorial',
    title: '【教程】樱花梦境系插画创作全流程分享',
    excerpt: '从构思到完稿，带你走进樱花梦境般的插画世界。本文将分享完整的创作流程，包括色彩搭配、光影处理以及氛围营造等核心技巧。',
    content: `<h2>前言</h2><p>樱花梦境系列是我在过去一年中持续创作的一个插画项目，以日系唯美风格为基础，融入了梦幻般的色彩和光影效果。今天我将完整分享我的创作流程和心得体会。</p><h2>一、灵感来源与构思</h2><p>这个系列的灵感主要来源于日本动画电影中的唯美场景，特别是新海诚导演作品中对光影和天空的处理方式。在构思阶段，我会先确定画面的核心情感，然后围绕这个情感去选择色彩和构图。</p><h2>二、色彩搭配技巧</h2><p>樱花梦境系列主要使用了粉色系作为主色调，搭配浅蓝和淡紫作为辅色。关键是要保持色彩的和谐统一，避免过于鲜艳或突兀的颜色搭配。我通常会先在色环上确定主色调的位置，然后选择相邻的和谐色作为搭配。</p><h2>三、光影处理</h2><p>光影是营造氛围的关键。在这个系列中，我大量使用了柔和的逆光效果，让画面呈现出温暖而梦幻的感觉。具体技巧包括使用高斯模糊来模拟光晕效果，以及通过图层的叠加模式来增强光感。</p><h2>四、细节刻画</h2><p>虽然整体风格偏向写意，但关键区域的细节刻画仍然很重要。比如人物的眼睛、头发的光泽、花瓣的纹理等，这些细节能够提升画面的质感和完成度。</p><h2>结语</h2><p>希望这篇分享能够给大家带来一些启发。创作是一个不断探索和进步的过程，最重要的是保持热爱和耐心。期待看到大家的作品！</p>`,
    category: 'illustration',
    categoryName: '插画作品',
    author: '樱月画师',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20female%20avatar%20with%20pink%20hair%2C%20gentle%20smile%2C%20soft%20pastel%20colors%2C%20clean%20background%2C%20kawaii%20illustration&width=80&height=80&seq=author-sakura&orientation=squarish',
    publishDate: '2026-08-01',
    readTime: '8 分钟',
    viewCount: 15280,
    likeCount: 3421,
    commentCount: 567,
    tags: ['插画教程', '樱花', '日系', '创作分享', '色彩'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20illustration%20of%20cherry%20blossom%20dreamscape%20with%20soft%20pink%20and%20blue%20colors%2C%20floating%20petals%2C%20dreamy%20atmosphere%2C%20Japanese%20anime%20art%20style%2C%20soft%20lighting%2C%20ethereal%20and%20romantic%20mood&width=800&height=500&seq=article-sakura-01&orientation=landscape',
    featured: true,
  },
  {
    id: '2',
    slug: 'star-river-comic-chapter-12',
    title: '《星河纪元》第 12 话 - 星辰彼岸的约定',
    excerpt: '原创长篇漫画《星河纪元》最新话火热更新！主角团终于抵达了传说中的星之遗迹，却发现了颠覆认知的秘密。',
    content: `<h2>前情提要</h2><p>在上一话中，主角小队穿越了危险的陨石带，终于隐约看到了星之遗迹的轮廓。而暗影组织的追兵也在步步紧逼，时间越来越紧迫。</p><h2>本话内容</h2><p>当主角们踏入星之遗迹的那一刻，所有人都被眼前的景象震撼了。巨大的水晶柱群散发着柔和的光芒，古老的壁画讲述着早已被遗忘的文明。</p><p>"这就是……星之遗迹吗？"小月喃喃自语，伸手触摸着水晶柱的表面。突然，一道光芒从她的手掌扩散开来，整个遗迹开始震动。</p><p>壁画上的图案开始流动，像是活过来了一样。一幅幅画面在众人眼前展开，展示着这个远古文明的兴衰史。</p><p>"原来如此……我们一直以来的认知都是错的。"队长林风紧皱着眉头，"这里根本不是坟墓，而是一个……警示。"</p><p>壁画最后展示的画面让所有人心头一紧——那是与暗影组织首领身上完全相同的符号。</p><h2>下话预告</h2><p>暗影组织的追兵已经抵达遗迹外围！下一话将迎来激烈的战斗场面，敬请期待！</p>`,
    category: 'comic',
    categoryName: '漫画连载',
    author: '星河工作室',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20studio%20logo%20avatar%20with%20stars%20and%20galaxy%20theme%2C%20dark%20blue%20and%20gold%20colors%2C%20clean%20minimal%20design&width=80&height=80&seq=author-star&orientation=squarish',
    publishDate: '2026-08-05',
    readTime: '5 分钟',
    viewCount: 28950,
    likeCount: 5620,
    commentCount: 1203,
    tags: ['星河纪元', '原创漫画', '科幻', '冒险', '连载'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20anime%20scene%20with%20ancient%20crystal%20ruins%20and%20starry%20sky%2C%20adventure%20explorers%20discovering%20mysterious%20artifacts%2C%20dramatic%20lighting%2C%20Japanese%20anime%20style%2C%20cinematic%20composition&width=800&height=500&seq=article-star-01&orientation=landscape',
    featured: true,
  },
  {
    id: '3',
    slug: 'summer-festival-doujin-collection',
    title: '夏日祭典同人画集 - 当经典角色穿上浴衣',
    excerpt: '一年一度的夏日祭典主题同人画集来了！多位画师笔下的经典角色身着浴衣，在烟火下绽放最美的笑容。',
    content: `<h2>画集前言</h2><p>夏日祭典，是二次元文化中最具代表性的场景之一。烟火、浴衣、苹果糖、捞金鱼……这些元素构成了我们心中最美好的夏日记忆。</p><p>本次同人画集我们邀请了 30 位知名同人画师，让他们用画笔描绘出自己心目中最喜爱的角色在夏日祭典中的样子。</p><h2>精选作品展示</h2><p>每一幅作品都凝结了画师对角色深深的喜爱和理解。从服装设计到场景构图，从色彩搭配到氛围营造，都是经过反复推敲的成果。</p><p>特别值得一提的是，本次画集中有多位画师选择了"烟火下的回眸"这一经典构图，但每位画师都赋予了完全不同的情感表达——有的温柔，有的活泼，有的带着一丝淡淡的忧伤。</p><h2>创作背后的故事</h2><p>画师"星空糖"分享道："我一直想在夏日祭典的场景中画出角色的另一面。穿上浴衣后，角色仿佛从激烈的战斗中暂时抽离，展现出日常生活中柔软的一面。"</p><h2>结语</h2><p>感谢所有参与创作的画师和一直支持我们的读者。愿这份夏日的温暖，能陪伴你度过每一个美好的瞬间。</p>`,
    category: 'doujin',
    categoryName: '同人创作',
    author: '萝幼社编辑部',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20editor%20avatar%20with%20glasses%20and%20notebook%2C%20friendly%20smile%2C%20warm%20orange%20and%20brown%20colors%2C%20clean%20simple%20design&width=80&height=80&seq=author-editor&orientation=squarish',
    publishDate: '2026-08-03',
    readTime: '6 分钟',
    viewCount: 18920,
    likeCount: 4230,
    commentCount: 891,
    tags: ['同人画集', '夏日祭典', '浴衣', '烟火', '合集'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20characters%20in%20yukata%20at%20summer%20festival%20with%20fireworks%20in%20night%20sky%2C%20warm%20lantern%20lighting%2C%20festive%20atmosphere%2C%20Japanese%20festival%20scene%2C%20colorful%20and%20joyful%20mood%2C%20beautiful%20illustration&width=800&height=500&seq=article-summer-01&orientation=landscape',
    featured: true,
  },
  {
    id: '4',
    slug: 'cosplay-photography-lighting-guide',
    title: 'Cos 摄影灯光全攻略：从入门到精通',
    excerpt: '好的灯光能让 Cos 作品提升不止一个档次。本文详细讲解了自然光、棚拍光和各种特效灯光的运用技巧。',
    content: `<h2>为什么灯光如此重要？</h2><p>在 Cos 摄影中，灯光往往是被忽视但至关重要的环节。即使拥有完美的服装和妆容，如果灯光处理不当，最终效果也会大打折扣。相反，合理的灯光布置可以让普通的场景变得富有戏剧性。</p><h2>一、自然光的运用</h2><p>对于户外 Cos 拍摄来说，自然光是最好的光源。黄金时段（日出后和日落前的一小时）的光线最为柔和温暖，能营造出梦幻般的氛围。正午的强光则适合拍摄高对比度的战斗场景。</p><h2>二、棚拍基础灯光</h2><p>棚拍中最常用的是三点式布光法：主光源提供主要照明，辅光源消除阴影，轮廓光分离主体和背景。掌握这三点，就能应对大部分拍摄需求。</p><h2>三、创意特效灯光</h2><p>对于奇幻题材的 Cos，可以尝试使用彩色滤光片、烟雾机配合灯光来营造魔法或科幻效果。RGB 灯棒也是近年来非常流行的创意灯光工具。</p><h2>总结</h2><p>灯光的本质是为角色和故事服务的。理解角色的性格和场景的氛围，才能用好灯光来讲述你想要的故事。</p>`,
    category: 'cosplay',
    categoryName: 'Cosplay',
    author: '光影师阿杰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cool%20photographer%20avatar%20with%20camera%2C%20anime%20style%2C%20dark%20hair%2C%20professional%20look%2C%20clean%20background&width=80&height=80&seq=author-light&orientation=squarish',
    publishDate: '2026-07-28',
    readTime: '10 分钟',
    viewCount: 9870,
    likeCount: 2150,
    commentCount: 342,
    tags: ['Cos摄影', '灯光教程', '摄影技巧', '棚拍'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20cosplay%20photography%20studio%20setup%20with%20lighting%20equipment%2C%20soft%20boxes%20and%20reflectors%2C%20anime%20character%20cosplay%20shoot%2C%20warm%20studio%20atmosphere%2C%20creative%20photography%20scene&width=800&height=500&seq=article-cos-01&orientation=landscape',
    featured: false,
  },
  {
    id: '5',
    slug: 'voice-acting-emotion-technique',
    title: '声优的必修课：如何用声音传达情感',
    excerpt: '资深声优导师分享声音情感表达的核心技巧，从呼吸控制到情绪代入，教你如何用声音打动人心。',
    content: `<h2>声音是情感的载体</h2><p>在二次元作品中，声优的表演是将角色从纸面带入现实的关键桥梁。一句台词，同样的文字，不同的语气和情感处理，可以传达出完全不同的意义。</p><h2>呼吸是基础</h2><p>很多新手声优会忽略呼吸的重要性。正确的腹式呼吸不仅能让声音更加稳定有力，还能帮助你更好地控制语气中的情感变化。练习时可以先从简单的深呼吸开始，感受气息的流动。</p><h2>情感代入技巧</h2><p>要真正传达情感，光有技巧是不够的。你需要深入理解角色的背景、性格和当下所处的场景。我建议在配音前，先写下角色的"内心独白"，这会帮助你在配音时更加投入。</p><h2>常见情感处理</h2><p>喜悦、悲伤、愤怒、恐惧——每种情感都有其独特的声音特征。喜悦时声音会更明亮高昂，悲伤时声音会变得低沉缓慢。通过反复练习和录音回听来打磨这些细节。</p>`,
    category: 'voice',
    categoryName: '声优配音',
    author: '声之导师琳琳',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Friendly%20anime%20style%20voice%20actor%20avatar%20with%20headphones%2C%20warm%20smile%2C%20soft%20pastel%20colors%2C%20clean%20background&width=80&height=80&seq=author-voice&orientation=squarish',
    publishDate: '2026-07-25',
    readTime: '7 分钟',
    viewCount: 7650,
    likeCount: 1890,
    commentCount: 276,
    tags: ['声优', '配音技巧', '情感表达', '声音训练'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20voice%20actor%20in%20recording%20booth%20with%20script%20and%20microphone%2C%20warm%20studio%20lighting%2C%20focused%20expression%2C%20professional%20recording%20environment%2C%20creative%20atmosphere&width=800&height=500&seq=article-voice-01&orientation=landscape',
    featured: false,
  },
  {
    id: '6',
    slug: 'short-animation-frame-by-frame-basics',
    title: '逐帧动画入门：从第一个 bouncing ball 开始',
    excerpt: '想学动画但不知从何下手？这篇入门指南带你从最经典的弹跳球练习开始，逐步掌握逐帧动画的基本原理。',
    content: `<h2>动画的十二原则</h2><p>在开始动手之前，先了解迪士尼动画师总结的动画十二原则是非常重要的。其中挤压与拉伸、预备动作、跟随与重叠动作是最基础也是最核心的原则。</p><h2>弹跳球练习</h2><p>弹跳球是每个动画师的第一课。通过一个简单的球体弹跳，你可以练习挤压与拉伸、缓入缓出、弧线运动等多个动画基本原则。建议先用 24 帧每秒的速率，画一个完整的弹跳循环。</p><h2>关键帧与中间帧</h2><p>理解了关键帧（Keyframe）和中间帧（Inbetween）的区别，你就掌握了动画制作的核心思路。关键帧定义了动作的起始和结束状态，中间帧则是连接它们的过渡。</p><h2>推荐工具</h2><p>对于初学者，推荐使用 Krita（免费开源）或 TVPaint。如果预算充足，Toon Boom Harmony 是业界标准。当然，传统的纸笔练习也永远不会过时。</p>`,
    category: 'animation',
    categoryName: '动画短片',
    author: '动画新人小C',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20animator%20avatar%20with%20drawing%20tablet%2C%20creative%20look%2C%20colorful%20style%2C%20clean%20background&width=80&height=80&seq=author-anim&orientation=squarish',
    publishDate: '2026-07-20',
    readTime: '9 分钟',
    viewCount: 12450,
    likeCount: 2780,
    commentCount: 445,
    tags: ['动画教程', '逐帧动画', '入门指南', '动画原理'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Animation%20desk%20with%20light%20table%20and%20drawing%20materials%2C%20frame%20by%20frame%20animation%20sequence%2C%20bouncing%20ball%20sketches%2C%20warm%20creative%20workspace%2C%20artistic%20and%20organized%20environment&width=800&height=500&seq=article-anim-01&orientation=landscape',
    featured: false,
  },
  {
    id: '7',
    slug: 'digital-painting-color-theory',
    title: '数字绘画色彩理论：让你的画面更出彩',
    excerpt: '色彩是插画中最重要的视觉元素之一。掌握科学的色彩理论，让你的作品从"好看"进阶到"惊艳"。',
    content: `<h2>色彩基础理论</h2><p>理解色相、饱和度和明度这三个基本属性是掌握色彩理论的第一步。色相决定颜色的种类，饱和度决定颜色的纯度，明度决定颜色的亮度。</p><h2>配色方案</h2><p>常见的配色方案包括：互补色、邻近色、三角配色和分裂互补色。每种方案都有其独特的情感表达和视觉效果。初学者建议从邻近色配色开始，这是最不容易出错的方案。</p><h2>冷暖对比</h2><p>冷色和暖色的对比是创造画面深度的有效方法。一般来说，亮部偏暖、暗部偏冷会让画面更加生动。但也可以故意打破这个规则来创造独特的视觉效果。</p><h2>色彩心理学</h2><p>不同的颜色会引发不同的情感反应。红色代表热情和能量，蓝色代表冷静和信任，绿色代表自然和希望，紫色代表神秘和优雅。理解色彩心理学，让你的作品更有表达力。</p>`,
    category: 'illustration',
    categoryName: '插画作品',
    author: '色彩魔法师小蓝',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Artistic%20anime%20style%20painter%20avatar%20with%20color%20palette%2C%20creative%20expression%2C%20bright%20and%20cheerful%20colors&width=80&height=80&seq=author-color&orientation=squarish',
    publishDate: '2026-07-18',
    readTime: '7 分钟',
    viewCount: 11340,
    likeCount: 2560,
    commentCount: 389,
    tags: ['插画', '色彩理论', '数字绘画', '配色'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20digital%20painting%20workspace%20with%20color%20wheel%20and%20palettes%2C%20anime%20style%20illustration%20in%20progress%2C%20vibrant%20and%20harmonious%20colors%2C%20creative%20digital%20art%20environment&width=800&height=500&seq=article-color-01&orientation=landscape',
    featured: false,
  },
  {
    id: '8',
    slug: 'cosplay-prop-making-tutorial',
    title: 'Cos 道具制作全攻略：从设计图到成品',
    excerpt: 'EVA 泡沫、热熔胶、喷漆……利用这些常见材料，你也能做出还原度超高的 Cos 道具。完整教程来了！',
    content: `<h2>道具是 Cos 的灵魂</h2><p>一件制作精良的道具可以让整个 Cos 作品的还原度提升好几个档次。但很多 Coser 觉得道具制作门槛太高，其实只要掌握基本技巧，人人都能做出令人满意的道具。</p><h2>材料选择</h2><p>EVA 泡沫是最常用的 Cos 道具材料，轻便、易加工且成本低廉。厚度从 2mm 到 10mm 不等，可以根据道具的大小和结构需求进行选择。此外，PVC 管、热熔胶、丙烯颜料也是常用材料。</p><h2>制作流程</h2><p>首先根据参考图绘制设计图，确定各部分的尺寸。然后在 EVA 泡沫上画出形状并切割，使用热风枪加热塑形，再用热熔胶进行组装。最后经过打磨、上底漆、喷漆和做旧处理，一件道具就完成了。</p>`,
    category: 'cosplay',
    categoryName: 'Cosplay',
    author: '道具工坊老王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20craftsman%20avatar%20with%20tools%2C%20friendly%20expression%2C%20warm%20brown%20tones%2C%20clean%20background&width=80&height=80&seq=author-prop&orientation=squarish',
    publishDate: '2026-07-15',
    readTime: '11 分钟',
    viewCount: 14560,
    likeCount: 3210,
    commentCount: 534,
    tags: ['Cos道具', '手工制作', 'EVA泡沫', '教程'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Cosplay%20prop%20making%20workshop%20with%20EVA%20foam%20materials%20and%20tools%2C%20weapon%20prop%20in%20progress%2C%20organized%20crafting%20desk%2C%20warm%20workshop%20lighting%2C%20creative%20and%20practical%20atmosphere&width=800&height=500&seq=article-prop-01&orientation=landscape',
    featured: false,
  },
];

export const featuredArticles = articles.filter((a) => a.featured);
export const latestArticles = articles.filter((a) => !a.featured);

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.category === categorySlug);
}

export function getRelatedArticles(article: Article, count: number = 3): Article[] {
  return articles
    .filter((a) => a.category === article.category && a.id !== article.id)
    .slice(0, count);
}